/*
  Панель под любым списком или таблицей (21.10.2026, замечание владельца): сколько
  всего записей, сколько на странице, «Назад - Вперёд».

  Число записей показывается всегда, даже у короткого списка: «Всего записей: 3»
  отвечает на вопрос «это всё или есть ещё». Выбор размера страницы и кнопки появляются,
  когда записей больше наименьшего размера страницы (10): у списка из трёх строк им
  нечего делать, а панель из пяти элементов под тремя строками - шум.

  Панель только рисует и сообщает о выборе; какие строки показать, решает `usePaging`
  (или сервер, у реестра).
*/

import { useId } from 'react'

import { PAGE_SIZES } from './usePaging.js'
import Dropdown from './Select.jsx'

const SIZE_OPTIONS = Object.fromEntries(PAGE_SIZES.map((size) => [String(size), String(size)]))

export default function PageBar({ total, size, page, pages, onPage, onSize, what = 'записей' }) {
  const labelId = useId()
  if (!total) return null
  const from = page * size + 1
  const to = Math.min((page + 1) * size, total)

  return (
    <div className="pager">
      <span className="muted pager__count">
        Всего {what}: {total}
      </span>
      {total > PAGE_SIZES[0] ? (
        <div className="pager__controls">
          <span className="muted" id={labelId}>
            На странице
          </span>
          <Dropdown
            value={String(size)}
            onChange={onSize}
            options={SIZE_OPTIONS}
            labelledBy={labelId}
          />
          <span className="muted pager__range">
            {from}-{to} из {total}
          </span>
          <button
            type="button"
            className="button button--quiet"
            disabled={page === 0}
            onClick={() => onPage(page - 1)}
          >
            Назад
          </button>
          <button
            type="button"
            className="button button--quiet"
            disabled={page >= pages - 1}
            onClick={() => onPage(page + 1)}
          >
            Вперёд
          </button>
        </div>
      ) : null}
    </div>
  )
}
